import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { IntegratedIReckonHotel, IntegrationIReckonHotelsAndUnitsService } from '@era/locations-sdk';
import {
  IReckonIntegratedHotelResolverActions,
  IReckonIntegratedHotelApiActions,
  IReckonIntegratedHotelContainerActions,
} from './integrated-ireckon-hotel.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class IReckonHotelEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly hotelService: IntegrationIReckonHotelsAndUnitsService
  ) {}

  hotelsLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelResolverActions.integrationRequested),
      mergeMap(({ locationUniqueId }) =>
        safeMap(
          this.hotelService.getIntegratedIReckonHotels(null, locationUniqueId),
          (result: IntegratedIReckonHotel[]) => IReckonIntegratedHotelApiActions.integrationsLoaded({ hotels: result }),
          (error) => IReckonIntegratedHotelApiActions.integrationsLoadedError({ error })
        )
      )
    );
  });

  hotelUpdatedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(IReckonIntegratedHotelContainerActions.integrationUpdated),
      mergeMap(({ hotel }) =>
        hotel.id
          ? safeMap(
              this.hotelService.updateIntegratedIReckonHotel(hotel.id, hotel),
              () => IReckonIntegratedHotelApiActions.integrationsUpdated({ hotel }),
              (error) => IReckonIntegratedHotelApiActions.integrationsUpdatedError({ hotel, error })
            )
          : safeMap(
              this.hotelService.addIntegratedIReckonHotel(hotel),
              () => IReckonIntegratedHotelApiActions.integrationsAdded({ hotel }),
              (error) => IReckonIntegratedHotelApiActions.integrationsAddedError({ hotel, error })
            )
      )
    );
  });
}
